<template>
    <div class="footer text_11 color-text_3">
        <div class="container">
            <div class="row">
                <div class="col lg-6 sm-12">
                    <nuxt-link to="/dostavka/">{{ $t("help_delivery") }}</nuxt-link>
                    <nuxt-link to="/vozvrat/">{{ $t("return") }}</nuxt-link>
                    <nuxt-link to="/faq/">{{ $t("faq") }}</nuxt-link>
                    <nuxt-link to="/dokumenty/">{{ $t("docs") }}</nuxt-link>
                </div>
                <div class="col lg-6 sm-12" :class="{ tar: $device.isDesktop }">p.p.s. {{ year }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "FooterInner",
    data() {
        return {
            year: new Date().getFullYear(),
        };
    },
};
</script>
<style scoped lang="less">
// @import "@/assets/less/vars.less";

.footer {
    border-top: 1px @border2 solid;
    display: flex;
    height: 36px;
    align-items: center;
    @media @sm {
        height: auto;
        padding-top: 24px;
        a {
            width: 50%;
        }
    }
    .row {
        flex-grow: 1;
    }
    a + a {
        margin-left: 24px;
        @media @sm {
            margin-left: 0;
            margin-bottom: 16px;
        }
    }
    .col {
        @media @sm {
            display: flex;
            flex-wrap: wrap;
            + .col {
                margin-top: 24px;
                border-top: 1px solid @border2;
                height: 30px;
                align-items: center;
            }
        }
    }
}
</style>
